export default "__VITE_ASSET__CrIuu29p__"